import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import TRANSLATION_EN, { getTranslationEN } from './translations/en';
import TRANSLATION_SR, { getTranslationSR } from './translations/sr';

i18n.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: localStorage.getItem('locale') || 'en',
		debug: false,
		resources: {
			en: {
				translation: getTranslationEN(),
			},
			sr: {
				translation: getTranslationSR(),
			},
		},
		detection: {
			order: ['queryString', 'cookie'],
			cache: ['cookie'],
		},
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
	});

export const addTranslations = (language, namespace, translationsObj) => {
	i18n.addResourceBundle(language, namespace, translationsObj, true, true);
};
export default i18n;
